const ASSET_BASE = `${process.env.PUBLIC_URL}/assets/images/raid2026`;

export const RAID_LOGO_SPLATTER_SRC = `${ASSET_BASE}/raid_green_splatter.svg`;
export const RAID_LOGO_WORDMARK_SRC = `${ASSET_BASE}/logo_raid_wordmark.svg`;
export const RAID_LOGO_SUMMER_SRC = `${ASSET_BASE}/text_summer_internship_2026.svg`;

export const RAID_FV_ASSET_URLS = [
  RAID_LOGO_SPLATTER_SRC,
  RAID_LOGO_WORDMARK_SRC,
  RAID_LOGO_SUMMER_SRC,
];

export const RAID_FV_BOOT_MIN_MS = 1000;
export const RAID_FV_BOOT_MAX_MS = 4000;
